export default [
  {
    path: '/app/config',
    name: 'AppConfig',
    component: () => import('@/views/Configs/Index.vue'),
    meta: {
      pageTitle: 'Ayarlar',
      breadcrumb: [
        {
          text: 'Genel Yapılandırma',
          active: true,
        },
      ],
      resource: 'APP_CONFIG',
      action: 'read',
    },
  },
]
